import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export const store = new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    auth: {
      token: null,
      athlete: null,
      lastUpdate: null
    },
    lastUpdate: {},
    activitiesFilter: {
      page: 1,
      maxDate: null,
      minDate: null
    },
    message: {
      text: null,
      type: null,
      visible: false
    }
  },
  getters: {
    isLoggedIn: state => {
      if (state.auth.token) return true;
      else return false;
    },
    athlete: state => {
      return state.auth.athlete;
    },
  },
  mutations: {
    initialiseStore(state) {
      if (localStorage.getItem('auth')) {
        Object.assign(state.auth, JSON.parse(localStorage.getItem('auth')));
      }
    },
    login: (state, payload) => {
      state.auth.token = payload.token;
      state.auth.athlete = payload.athlete;
      state.auth.lastUpdate = new Date();
    },
    logout: state => {
      state.auth.token = null;
      state.auth.athlete = null;
    },
    showMessage: (state, payload) => {
      state.message.text = payload.text;
      state.message.type = payload.type | 'info';
      state.message.visible = true;
      console.log(state.message);
    },
  },
});

store.subscribe((mutation, state) => {
  if (mutation.type === 'login' || mutation.type === 'logout') {
    localStorage.setItem('auth', JSON.stringify(state.auth));
  }
});